import React, { Component } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import { styled } from '@mui/system';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';


const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


export default class Statementsettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logredirect: false, pagename: '',bs_id:0,type:'',ao_id:0,label: 'Select Name',desc: '',
      redirect: false,bsid:'',ids:'',textcountmin:0,errormessage:'',Navigationdata:[],admindata:[],
textcountmax:2000, successMessage: '',submitbtn:'save',
      showSuccessMessage: false,
    };
  }




   
componentWillMount() {
	
	document.title = "Statement Settings";
	
if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		 this.props.parentdasCallback(
            "Statement Settings ~"
        );
	this.apicall();
	     

} 

PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=22')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
	
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
apicall() {
  let strset = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=6'+'&bs_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data.length > 0) {
        resp.data.map((row, i) => {
          const items = {
            bs_id: row.bs_id,
            bs_title: row.bs_title,
            bs_value:row.bs_value, 
            bs_page: row.bs_page,
		 };

          strset.push(items);
        });

     
        this.setState({
          Navigationdata: strset,
        });
      } else {
        this.setState({Navigationdata: []});
      }

    });
	this.getAdminoption();
}
   
getAdminoption() {
  let strset = [];
  axios
    .get(localStorage.getItem("ISIurl") +'ajaxadminoption.php?action=list&ao_type=5'+'&ao_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data.length > 0) {
        resp.data.map((row, i) => {
          const items = {
           ao_id: row.ao_id,
            ao_name: row.ao_name,
            ao_description:row.ao_description,
		 };

          strset.push(items);
        });

     
        this.setState({
          admindata: strset,
        });
      } else {
        this.setState({admindata: []});
      }

    });
}


  HandleNavigationSetting = (bs_id, index) => {
    return (event) => {
		const value = event.target.value; 
      const updatedData = [...this.state.Navigationdata];
      updatedData[index].bs_value = event.target.value;
      this.setState({ Navigationdata: updatedData });
    };
  }

	

  myChangeHandlerPV = (rows, bs_id) => {
    return (event) => {
      const updatedData = [...this.state.Navigationdata];
      updatedData[rows].bs_value = event.target.checked ? '1' : '0';
      this.setState({ Navigationdata: updatedData });
    };
  }


  myChangeHandler = (firstrow) => event  => { 
  let nam = event.target.name;
  let val = event.target.value;
    const updatearray = [...this.state.admindata]
	
	
	if(nam==="ao_description")
	{
		    if (val.length <= this.state.textcountmax) {
            this.setState({
                [nam]: val,           
                textcountmin: val.length 
            });
        }
		updatearray[firstrow].ao_description = val
	
	}
      this.setState({ admindata:updatearray }); 
	  
	  
 }





	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

  


    handleSubmit = (event) => {
    event.preventDefault();
      let optionsVals=this.state.Navigationdata;
    let sep1 = '';
    let optionValues = '';

	 
	  optionsVals.forEach(eachvals => {
     
		 optionValues=optionValues+sep1+eachvals.bs_id+"~"+eachvals.bs_value;
		 sep1="`"
		
		   
	   });
	  
    const formData = new FormData();
	
	
	formData.append('action','update')
	 formData.append('business',optionValues)
	 formData.append('bs_page',6)
	 
	 
     formData.append('bs_cmp_id',localStorage.getItem("ISIcmpid"))
     formData.append('userid',localStorage.getItem("ISIuserid"))
 

    axios.post(localStorage.getItem("ISIurl")+'ajaxbusinesssetting.php', formData)
      .then((res) => {
      this.setState({
            btndisabled: false,
            submitbtn: "Save",
         
            errormessage: "Updated Successfully", 
            erropen: true,
            successMessage: ' updated successfully!',
            showSuccessMessage: true,
          });
      })
	  
	    formData.append('action', 'BulkUpdate');
		 let optionsValues=this.state.admindata;
	   let optionadminValues="";
    let sep2="";
   optionsValues.forEach(eachval => {
       if(eachval.ao_id !== ""){
		 optionadminValues=optionadminValues+sep2+eachval.ao_id + "~" + eachval.ao_description;
		 sep2="`"
	   }
		   
	   });
		 formData.append('ao_description', optionadminValues);
	   axios.post(localStorage.getItem("ISIurl")+'ajaxadminoption.php', formData)
      .then((res) => {
     })
  
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
	<React.Fragment> 
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
      <div className="page-container">
  
  
  
  
    <div className="termsandcondition">
  <h3>STATEMENT TYPES AND DATA</h3>
  <p>Choose the type of statements to send and what's included on them. </p>
</div>

<div className="titleright">

<ul className="">
<li>
       {this.state.Navigationdata.map((item, index) => (
          <React.Fragment key={index}>
        {item.bs_id === "1" && (
		
		<FormControl style={{width:'40%'}}>
		<h6>{item.bs_title}</h6>
      <Select
				 native
				 variant="outlined"   
				  margin="normal"
				  onChange={this.HandleNavigationSetting(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="bs_value"
				 className="txtbox"
					inputProps={{tabIndex: "4"}}
					
				>
				
				<option selected="selected" value="activity">All activity</option>
<option value="outstanding">Outstanding items only</option>
				
			</Select>	
			</FormControl>
     )}
	  </React.Fragment> 
  ))}
   
</li>

<li>
       {this.state.Navigationdata.map((item, index) => (
          <React.Fragment key={index}>
        {item.bs_id === "2" && (
		
		<FormControl style={{width:'40%'}}>
		<h6>{item.bs_title}</h6>
      <Select
				 native
				 variant="outlined"   
				  margin="normal"
				  onChange={this.HandleNavigationSetting(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="bs_value"
				 className="txtbox"
					inputProps={{tabIndex: "4"}}
				>
				
				<option selected="selected" value="activity">All activity</option>
<option value="outstanding">Outstanding items only</option>	
				
			</Select>	
			</FormControl>
     )}
	  </React.Fragment> 
  ))}
   
</li>

<li>
       {this.state.Navigationdata.map((item, index) => (
          <React.Fragment key={index}>
        {item.bs_id === "3" && (
		
		<FormControl style={{width:'40%'}}>
		<h6>{item.bs_title}</h6>
      <Select
				 native
				 variant="outlined"   
				  margin="normal"
				  onChange={this.HandleNavigationSetting(item.bs_id, index)}
				  id="bs_value"
				 value={item.bs_value}
				 name="bs_value"
				 className="txtbox"
					inputProps={{tabIndex: "4"}}
				>
				
				
<option selected="selected" value="false">Email PDFs to customers</option>
<option value="true">Print Pdf's</option>
				
			</Select>	
			</FormControl>
     )}
	  </React.Fragment> 
  ))}
   
</li>


 
   
   <li>
  
{this.state.Navigationdata.map((rows, i) => (
    <React.Fragment key={rows.bs_id}>
	 {rows.bs_id === "4" && (
     <p><FormControlLabel
        label=<h6>{rows.bs_title}</h6>
        control={ <Checkbox   name="bs_value" sx={{
  
    '&.Mui-checked svg': {
      fill: 'black', 
    },
  }}value={rows.bs_value}onChange={this.myChangeHandlerPV(i, rows.bs_id)}
  checked={rows.bs_value === "1"}   inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>

	 )}
    </React.Fragment>
  ))}
  </li>
  
  
   <li>
  
{this.state.Navigationdata.map((rows, i) => (
    <React.Fragment key={rows.bs_id}>
	 {rows.bs_id === "5" && (
     <p><FormControlLabel
        label=<h6>{rows.bs_title}</h6>
        control={ <Checkbox   name="bs_value" sx={{
  
    '&.Mui-checked svg': {
      fill: 'black', 
    },
  }}value={rows.bs_value}onChange={this.myChangeHandlerPV(i, rows.bs_id)}
  checked={rows.bs_value === "1"}   inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>

	 )}
    </React.Fragment>
  ))}
  </li>
  
   <li>
  
{this.state.Navigationdata.map((rows, i) => (
    <React.Fragment key={rows.bs_id}>
	 {rows.bs_id === "6" && (
     <p><FormControlLabel
        label=<h6>{rows.bs_title}</h6>
        control={ <Checkbox   name="bs_value" sx={{
  
    '&.Mui-checked svg': {
      fill: 'black', 
    },
  }}value={rows.bs_value}onChange={this.myChangeHandlerPV(i, rows.bs_id)}
  checked={rows.bs_value === "1"}   inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>

	 )}
    </React.Fragment>
  ))}
  </li>
  
  <li>
  {this.state.Navigationdata.map((item, index) => (
    <React.Fragment key={index}>
	
       {item.bs_id === "7" && (
	  
                  <FormControl className="preference">
				   <h6>{item.bs_title}</h6>
                    <RadioGroup
                      value={item.bs_value}
                      onChange={this.HandleNavigationSetting(item.bs_id, index)}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="Include future dated payments"
                        control={<Radio />}
                      label={
    <span style={{ fontWeight: 'bold' }}>
    Include future dated payments.</span>
 
  }
                      />
                      <FormControlLabel
                        value="Exclude future dated payments"
                        control={<Radio />}
						
						  label={
    <span style={{ fontWeight: 'bold' }}>
     Exclude future dated payments.</span>
		
  }				
						/>
                    </RadioGroup>
                  </FormControl>  
       )}
    </React.Fragment>
  ))}
  
  </li>
  
  
  
 </ul>
</div>
<div className="clear"></div>
   
   
   
   
     <div className="termsandcondition">
  <h3>CUSTOMER STATEMENT NOTES</h3>
  <p>Add a note or other details to the footer of all customer statements. </p>
</div>  
   
   <div className="titleright">
    {this.state.admindata.map((item, index) => {
      return (
	  <ul>
        <li key={index}>
          <div className="admintext"> 
           
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                multiline
                rows={6}
                name="ao_description"
                onChange={this.myChangeHandler(index)}
                value={item.ao_description}
                autoComplete="ao_description"
                
              />
          
		   <p>You have used {this.state.textcountmin} of {this.state.textcountmax} characters</p>
          </div>
		 
		 </li>
		 </ul>
			
      );
	  
	  	
 
    })}
	</div>
 <div className="clear"></div>
  
   
   
  
		 <div className="salesaction">	
		 
        <Button
          type="submit"
          halfWidth
          variant="contained"
          color="primary"
          id="submit"
          className="frmSecondarybtn"
          onClick={this.handleSubmit}
          key="submitButton"
		  disabled={this.state.btndisabled}
        >
		{this.state.submitbtn}
        </Button>
		&nbsp;&nbsp;&nbsp;
		<Button variant="contained"  color="primary" className="frmSecondarybtn" onClick={this.onclickCancel}>
Cancel
</Button>
</div>

      </div>
	  </React.Fragment>
    );
  }
}